import { useContext } from 'react'
import { TableMatchContext } from './table-match-context'

/** Offsets are Unicode character positions supplied by PostgreSQL, not browser regex matches. */
export default function TableMatchText({ text, start = 0 }: { text: string; start?: number }) {
  const match = useContext(TableMatchContext)
  if (!match?.offsets.length) return <>{text}</>
  const characters = Array.from(text)
  const end = start + characters.length
  const parts = []
  let cursor = 0
  for (const offset of match.offsets) {
    if (offset + match.length <= start || offset >= end) continue
    const from = Math.max(0, offset - start)
    const to = Math.min(characters.length, offset + match.length - start)
    if (from > cursor) parts.push(characters.slice(cursor, from).join(''))
    const active = offset === match.activeOffset
    parts.push(
      <strong
        key={offset}
        data-active-search-match={active || undefined}
        className={active ? 'rounded bg-blue-200 text-blue-950 font-semibold' : 'font-semibold'}
      >
        {characters.slice(from, to).join('')}
      </strong>
    )
    cursor = to
  }
  parts.push(characters.slice(cursor).join(''))
  return <>{parts}</>
}
